import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '../pipes/pipes.module';
import { ThemeComponent } from './components/theme/theme.component';

@NgModule({
    imports: [
        CommonModule,
        PipesModule
    ],
    declarations: [ThemeComponent],
    exports: [ThemeComponent]
})
export class ThemeModule { }
